<template>
  <div class="w-full">
    <div class="shadow-lg">
      <!-- Enrich With Zoom Info -->

      <div class="pt-2 ml-[15px]">
        <div
          class="flex flex-row justify-between items-center pb-1.5 border-b border-b-gray-400"
        >
          <h3 class="text-sm align-middle">Company Info:</h3>
        </div>
        <div class="flex mt-2 rounded-sm pb-1">
          <div
            class="text-sm text-dark-primary pr-4 pl-1 border-b border-l border-t border-gray-400 rounded-l-md py-1"
          >
            Source
          </div>
          <div class="w-1/4 border border-gray-400">
            <DevAdminListBox
              class="w-full h-full text-black"
              placeholder="------------"
              v-model="source"
              :options="sourceOptions"
              :multiple="false"
            />
          </div>

          <button
            @click="enrichWithZoomInfo"
            class="text-sm align-middle hover:bg-dark-primary hover:text-white pr-10 border-r pl-2 border-b border-t border-gray-400 rounded-r-md"
          >
            Get ZI IDs and ZI Basic for Companies in Source
          </button>
        </div>
      </div>

      <!-- Find and Merge Duplicates -->

      <div class="ml-[15px]">
        <div
          class="flex flex-row justify-between items-center pb-0.5 border-b border-b-gray-400"
        >
          <h3 class="text-sm">Find and Merge Duplicates:</h3>
        </div>
        <div class="flex pt-2 pb-2 gap-3">
          <base-pill-button @click="setFindMergeText('Remove All UIUDS')"
            >Remove All UIUDS</base-pill-button
          >
          <base-pill-button
            @click="setFindMergeText('Find and Mark UUIDs via URL')"
            >Find and Mark UUIDs via URL</base-pill-button
          >
          <base-pill-button
            @click="setFindMergeText('Find and Mark UUIDs via OIN')"
            >Find and Mark UUIDs via OIN</base-pill-button
          >
          <base-pill-button @click="setFindMergeText('Batch Merge Duplicates')"
            >Batch Merge Duplicates</base-pill-button
          >
        </div>
      </div>
    </div>

    <!-- Delete Warning -->

    <ConfirmScreen
      v-if="isConfirmModalVisible"
      :message="confirmText"
      @close-confirm-modal="closeConfirmModal"
      @confirm-modal="confirmActionDispatch"
    ></ConfirmScreen>

    <!-- Header Component -->
    <base-card>
          <div class="ml-[15px]">
        <div
          class="flex flex-row justify-between items-center pb-0.5 border-b border-b-gray-400"
        >
          <h3 class="text-sm">Audit Logs</h3>
        </div>

      </div>
      <base-pagination-header
        @load-data="loadLogs(fetchFilterLogs, true)"
        @get-next="getNextLogs"
        @go-to-first="goToFirstLogs"
        @get-prev="getPrevLogs"
        @go-to-last="goToLastLogs"
        @jump-to-page="jumpToPageLogs"
        @set-page-size-filter="setPageSizeFilterLogs"
        :page_filter="adminFilters"
        :page="pageLogs"
        :numPages="logPageCount"
        :is-loading="logsLoading"
      >
        <template v-slot:message>
          <div class="ml-3 mt-1">
            {{ countLogs }} activities in the last 30 minutes.
          </div>
        </template>
      </base-pagination-header>

      <!-- Table Component -->

      <div class="h-full overflow-y-auto border ml-2">
        <base-table-full lass="table-auto">
          <template #table-header>
            <base-table-header
              :key="header.id"
              :header="header"
              class="pt-3 pb-3"
              v-for="header in logTableHeadersList"
            >
              {{ header }}
            </base-table-header>
          </template>

          <template #table-body>
            <DevAdminRow
              v-for="log in logs"
              :key="log.id"
              :log="log"
            ></DevAdminRow>
          </template>
        </base-table-full>
      </div>
    </base-card>
    <base-card>
          <div class="ml-[15px]">
        <div
          class="flex flex-row justify-between items-center pb-0.5 border-b border-b-gray-400"
        >
          <h3 class="text-sm">Company Website Spider ({{ companySpiderQueueLength }} companies in queue)</h3>
        </div>
        <div class="flex pt-2 pb-2 gap-3">
          <div class="flex items-center" v-if="activeJobExists">
            <div class="text-sm mr-2">
              Running 
            </div>
            <div class="w-10 h-10 flex items-center">
                <LoadingSpinner />
            </div>
          </div>
          <div class="flex items-center text-sm w-full" v-else>
            <input class="p-1 w-32 text-xs h-8 border border-gray-400 rounded-l-md" type="number" min="0" max="100" placeholder="company count" v-model="spiderCrawlData.crawl_size"/>
            <button
            class="
              rounded-r-md
              h-8
              text-xs
              px-2
              py-1
              border-solid
              border-1
              border-light-primary
              bg-light-primary
              hover:bg-accent-primary
              focus:bg-accent-primary
              active:bg-accent-secondary
              hover:text-white
              focus:text-white
              active:text-white
              text-primary-dark
              cursor-pointer
            "
             @click="runSpider">Run Spider</button>
          </div>
        </div>

      </div>
      <base-pagination-header
        @load-data="loadSpiderJobs(fetchFilterLogs, true)"
        @get-next="getNextSpiderJobs"
        @go-to-first="goToFirstSpiderJobs"
        @get-prev="getPrevSpiderJobs"
        @go-to-last="goToLastSpiderJobs"
        @jump-to-page="jumpToPageSpiderJobs"
        @set-page-size-filter="setPageSizeFilterSpiderJobs"
        :page_filter="spiderJobFilters"
        :page="pageSpiderJobs"
        :numPages="spiderJobsPageCount"
        :is-loading="spiderJobsLoading"
      >
      </base-pagination-header>

      <!-- Table Component -->

      <div class="h-full overflow-y-auto border ml-2">
        <base-table-full lass="table-auto">
          <template #table-header>
            <base-table-header
              :key="header.id"
              :header="header"
              class="pt-3 pb-3"
              v-for="header in spiderJobTableHeadersList"
            >
              {{ header }}
            </base-table-header>
          </template>

          <template #table-body>
            <CompanyWebsiteSpiderJobsRow
              v-for="job in spiderJobs"
              :key="job.id"
              :spider-job="job"
            ></CompanyWebsiteSpiderJobsRow>
          </template>
        </base-table-full>
      </div>
    </base-card>
  </div>
</template>

<script>
export default {
  name: "aerocle-admin",
};
</script>

<script setup>
import { ref, computed, onMounted, reactive } from "vue";
import {
  getLogs,
  removeAllUUIDS,
  findAndMarkUUIDSViaUrl,
  findAndMarkUUIDSViaOin,
  batchMergeDuplicates,
} from "../services/Admin.js";
import { useStore } from "vuex";
import { getSources } from "../services/Source.js";
import { getCompanySpiderQueueLength } from "@/services/Company.js";
import { runCompanyWebsiteSpider, getCompanyWebsiteSpiderJobs } from "@/services/CompanyWebsiteSpiderCrawlJob.js";
import DevAdminRow from "./admin_page/table/AdminRow.vue";
import CompanyWebsiteSpiderJobsRow from "./admin_page/table/CompanyWebsiteSpiderJobsRow.vue";
import DevAdminListBox from "./admin_page/UI/AdminListBox.vue";
import ConfirmScreen from "./admin_page/UI/AdminConfirmScreen.vue";
import { useToast } from "vue-toast-notification";
import LoadingSpinner from './base-components/LoadingSpinner.vue';

// constants/variables

const store = useStore();
const $toast = useToast();

const nextLogs = ref();
const prevLogs = ref();
const countLogs = ref();
const logPageCount = ref();
const pageSizeLogs = ref();
const nextSpiderJobs = ref();
const prevSpiderJobs = ref();
const countSpiderJobs = ref();
const spiderJobsPageCount = ref();
const pageSizeSpiderJobs = ref();
const source = ref("");
const pageLogs = ref(1);
const logsLoading = ref(false);
const pageSpiderJobs = ref(1);
const spiderJobsLoading = ref(false);
const logs = ref([]);
const spiderJobs = ref([]);
const sourceOptions = ref([]);
const isConfirmModalVisible = ref(false);
const confirmText = ref("");
const companySpiderQueueLength = ref(0)

async function loadCompanySpiderQueueLength(){
  const token = store.state.auth.token
  const response = await getCompanySpiderQueueLength(token)
  if(response.status == 200){
    companySpiderQueueLength.value = response.data.count
  }
}


const adminFilters = reactive({
  pageSizeFilter: 25,
});

const spiderJobFilters = reactive({
  pageSizeFilter: 50,
});

const logTableHeadersList = ref(["ID", "Title", "Details", "User", "Timestamp"]);
const spiderJobTableHeadersList = ref(["ID", "Status", "Created At", "User", "Start Time", "End Time", "Stats"]);

// computed values

async function runSpider(){
  if(spiderCrawlData.crawl_size < 1){
    $toast.open({
      message: "Please select a number of companies to crawl greater than zero",
      type: "warning",
      duration: 3000
    })
    return
  }
  const token = store.state.auth.token
  const result = await runCompanyWebsiteSpider(token, spiderCrawlData)
  if(result.status == 200){
    $toast.open({
      message: "Running company website spider",
      type: 'success',
      duration: 3000
    })
    loadSpiderJobs()
  } else {
    $toast.open({
      message: "Error, could not run company website spider",
      type: 'error',
      duration: 3000
    })
  }
}

const fetchFilterLogs = computed(function () {
  let query = new URLSearchParams({});

  if (adminFilters.pageSizeFilter) {
    query.append("page_size", adminFilters.pageSizeFilter); // To append more data
  }

  let url;
  let queriesCount = 0;
  for (let value of query.values()) {
    queriesCount = queriesCount + 1;
  }
  if (queriesCount > 0) {
    url = "?" + query.toString();
  } else {
    url = "?";
  }
  return url;
});

const fetchFilterSpiderJobs = computed(function () {
  let query = new URLSearchParams({});

  if (spiderJobFilters.pageSizeFilter) {
    query.append("page_size", spiderJobFilters.pageSizeFilter); // To append more data
  }

  let url;
  let queriesCount = 0;
  for (let value of query.values()) {
    queriesCount = queriesCount + 1;
  }
  if (queriesCount > 0) {
    url = "?" + query.toString();
  } else {
    url = "?";
  }
  return url;
});

// async functions

async function loadLogs(endpoint = fetchFilterLogs.value, retainSpot) {
  logsLoading.value = true;
  let payload = {
    token: store.state.auth.token,
    endpoint: retainSpot ? endpoint + `&page=${pageLogs.value}` : endpoint,
  };
  const response = await getLogs(payload);
  nextLogs.value = response.next ? `&page=${response.page + 1}` : null;
  prevLogs.value = response.prev ? `&page=${response.page - 1}` : null;
  countLogs.value = response.count;
  pageLogs.value = response.page;
  logPageCount.value = response.num_pages;
  logs.value = response.logs;
  pageSizeLogs.value = response.logs.length;
  logsLoading.value = false;
}

async function loadSpiderJobs(queryParams = fetchFilterSpiderJobs.value, retainSpot) {
  spiderJobsLoading.value = true;
  const token = store.state.auth.token
  const response = await getCompanyWebsiteSpiderJobs(token, queryParams);
  loadCompanySpiderQueueLength()
  nextSpiderJobs.value = response.data.next ? `&page=${response.data.page + 1}` : null;
  prevSpiderJobs.value = response.data.prev ? `&page=${response.data.page - 1}` : null;
  countSpiderJobs.value = response.data.count;
  pageSpiderJobs.value = response.data.page;
  spiderJobsPageCount.value = response.data.num_pages;
  spiderJobs.value = response.data.results;
  pageSizeSpiderJobs.value = response.data.results.length;
  spiderJobsLoading.value = false;
}

const activeJobExists = computed(() => {
  return spiderJobs.value.filter((job) => job.status == 'running' || job.status == 'queued').length > 0
})

async function setSourceOptions() {
  let token = store.state.auth.token;
  const result = await getSources(token);
  sourceOptions.value = [
    { value: "clear", label: "------------" },
    ...result.map((source) => {
      return {
        value: source.id,
        label: source.source_name,
      };
    }),
  ];
}

const spiderCrawlData = reactive({
  crawl_size: null
})

async function removeAllUIUDSCall() {
  const token = store.state.auth.token;
  alert("removeAllUIUDSCall");
  //   const result = await removeAllUUIDS(token);
  //   if (result.status == 200) {
  //     alert("Remove all UIUDS succeeded");
  //   } else {
  //     alert("Remove all UUIDS failed");
  //   }
}

async function findAndMarkUUIDSViaURLCall() {
  const token = store.state.auth.token;
  alert("findAndMarkUUIDSViaURLCall");
  //   const result = await findAndMarkUUIDSViaUrl(token);
  //   if (result.status == 200) {
  //     alert("Find and Mark UUIDS via URL succeeded");
  //   } else {
  //     alert("Find and Mark UUIDS via URL failed");
  //   }
}

async function findAndMarkUUIDSViaOINCall() {
  const token = store.state.auth.token;
  alert("findAndMarkUUIDSViaOINCall");
  //   const result = await findAndMarkUUIDSViaOin(token);
  //   if (result.status == 200) {
  //     alert("Find and Mark UUIDS via OIN succeeded");
  //   } else {
  //     alert("Find and Mark UUIDS via OIN failed");
  //   }
}

async function batchMergeDuplicatesCall() {
  const token = store.state.auth.token;
  alert("batchMergeDuplicatesCall");
  //   const result = await batchMergeDuplicates(token);
  //   if (result.status == 200) {
  //     alert("Batch Merge Duplicates succeeded");
  //   } else {
  //     alert("Batch Merge Duplicates failed");
  //   }
}

async function setPageSizeFilterLogs(target) {
  target == "clear"
    ? (adminFilters.pageSizeFilter = 25)
    : (adminFilters.pageSizeFilter = target);
  await loadLogs(fetchFilterLogs.value);
}

// functions

function getNextLogs() {
  if (nextLogs.value) {
    loadLogs(fetchFilterLogs.value + nextLogs.value);
  } else {
    alert("No next page");
  }
}

function getPrevLogs() {
  if (prevLogs.value) {
    loadLogs(fetchFilterLogs.value + prevLogs.value);
  } else {
    alert("No previous page");
  }
}

function goToFirstLogs() {
  if (pageLogs.value != 1) {
    loadLogs(fetchFilterLogs.value + `&page=${1}`);
  } else {
    alert("At first page");
  }
}

function goToLastLogs() {
  if (logPageCount.value != pageLogs.value) {
    loadLogs(fetchFilterLogs.value + `&page=${logPageCount.value}`);
  } else {
    alert("At last page");
  }
}

function jumpToPageLogs(targetPage) {
  loadLogs(fetchFilterLogs.value + `&page=${targetPage}`);
}

async function setPageSizeFilterSpiderJobs(target) {
  target == "clear"
    ? (spiderJobFilters.pageSizeFilter = 50)
    : (spiderJobFilters.pageSizeFilter = target);
  await loadSpiderJobs(fetchFilterSpiderJobs.value);
}

// functions

function getNextSpiderJobs() {
  if (nextSpiderJobs.value) {
    loadSpiderJobs(fetchFilterSpiderJobs.value + nextSpiderJobs.value);
  } else {
    alert("No next page");
  }
}

function getPrevSpiderJobs() {
  if (prevSpiderJobs.value) {
    loadSpiderJobs(fetchFilterSpiderJobs.value + prevSpiderJobs.value);
  } else {
    alert("No previous page");
  }
}

function goToFirstSpiderJobs() {
  if (pageSpiderJobs.value != 1) {
    loadSpiderJobs(fetchFilterSpiderJobs.value + `&page=${1}`);
  } else {
    alert("At first page");
  }
}

function goToLastSpiderJobs() {
  if (logPageCount.value != pageSpiderJobs.value) {
    loadSpiderJobs(fetchFilterSpiderJobs.value + `&page=${spiderJobsPageCount.value}`);
  } else {
    alert("At last page");
  }
}

function jumpToPageSpiderJobs(targetPage) {
  loadSpiderJobs(fetchFilterSpiderJobs.value + `&page=${targetPage}`);
}

function enrichWithZoomInfo() {
  if (source.value !== "" && source.value !== "clear") {
    alert(source.value);
  }
}

function closeConfirmModal() {
  isConfirmModalVisible.value = false;
}

function setFindMergeText(text) {
  confirmText.value = text;
  isConfirmModalVisible.value = true;
}

function confirmActionDispatch(message) {
  if (message === "Remove All UIUDS") {
    removeAllUIUDSCall();
  } else if (message === "Find and Mark UUIDs via URL") {
    findAndMarkUUIDSViaURLCall();
  } else if (message === "Find and Mark UUIDs via OIN") {
    findAndMarkUUIDSViaOINCall();
  } else {
    batchMergeDuplicatesCall();
  }
  closeConfirmModal();
}

// lifecyle

onMounted(() => {
  loadLogs();
  setSourceOptions();
  loadSpiderJobs()
  loadCompanySpiderQueueLength()
});
</script>
